import React, { memo } from 'react';

// styles
import { Info } from './styles';

interface Props {
  isOutOfStock: boolean;
  stockRemaining?: number | boolean;
}

const SOLD_OUT = 'sold out';
const STOCK_LEFT_TEXT = 'left';

function StockInfo({ isOutOfStock, stockRemaining }: Props) {
  if (isOutOfStock) {
    return (
      <Info data-at="size-stock-soldout" isOutOfStock={isOutOfStock}>
        {SOLD_OUT}
      </Info>
    );
  }

  if (stockRemaining) {
    return (
      <Info data-at="size-stock-left">
        {stockRemaining}&nbsp;{STOCK_LEFT_TEXT}
      </Info>
    );
  }

  return null;
}

export default memo(StockInfo);
